import { action, observable, reaction } from 'mobx';
// import { isMobile } from 'styles/utils';
import { routerStore } from 'core/routing';

export class ChatControl {
  @observable chatVisible = false;

  constructor() {
    reaction(
      () => routerStore.route.params.panel,
      panelParam => {
        if (panelParam === 'discuss') {
          this.toggleChatVisibility(true);
        } else {
          this.toggleChatVisibility(false);
        }
      },
      { fireImmediately: true },
    );
  }

  /**
   * function to toggle the chat visibility
   * @param {boolean} value if provided then it will be set as the value
   */
  @action toggleChatVisibility(value) {
    if (value !== undefined) {
      this.chatVisible = value;
      return;
    }

    this.chatVisible = !this.chatVisible;
  }
}
